/* Normalize visible copy, including app-rendered content, without altering product data. */
(() => {
  const tidy = text => text
    .replace(/\u2014/g, '-')
    .replace(/\u2764\uFE0F?/g, 'heart')
    .replace(/[\u2190-\u21FF]/g, '')
    .replace(/[\p{Extended_Pictographic}\p{Regional_Indicator}\uFE0F\u200D\u20E3]/gu, symbol => ['©', '®', '™'].includes(symbol) ? symbol : '');
  const attributes = ['aria-label', 'title', 'placeholder', 'alt'];
  const ignored = 'script,style,textarea,code,pre,[contenteditable="true"]';
  function text(node) {
    if (node.parentElement?.closest(ignored)) return;
    const next = tidy(node.data);
    if (next !== node.data) node.data = next;
  }
  function attrs(element) {
    attributes.forEach(name => {
      const value = element.getAttribute(name);
      if (value && tidy(value) !== value) element.setAttribute(name, tidy(value));
    });
  }
  function scan(root) {
    if (root.nodeType === Node.TEXT_NODE) { text(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE || root.matches(ignored)) return;
    attrs(root);
    root.querySelectorAll('[aria-label],[title],[placeholder],[alt]').forEach(attrs);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) text(walker.currentNode);
  }
  scan(document.body);
  document.title = tidy(document.title);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'characterData') text(record.target);
      else if (record.type === 'attributes') attrs(record.target);
      else record.addedNodes.forEach(scan);
    });
  }).observe(document.body, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:attributes });
})();
